import { render } from "./Cases.vue?vue&type=template&id=89a1ec78&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"

import "./Cases.vue?vue&type=style&index=0&id=89a1ec78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a1ec78"]])

export default __exports__